document.addEventListener('DOMContentLoaded',()=>{
const productRoot=document.querySelector('.bogo-polycotton-product-section');
if(!productRoot)return;
const hero=document.getElementById('heroImage');
const count=document.querySelector('.mobile-gallery-count');
const thumbsWrap=document.querySelector('.thumbs');
const colorGalleries={
  Nero:[
    'https://cdn.shopify.com/s/files/1/0675/5329/6700/files/camicia-misto-cotone-clergy-nero-manica-lunga-ecclesiashop_65e38d9d-7ae2-40bf-a03c-3049f5b03a70.jpg?v=1790955797',
    'https://cdn.shopify.com/s/files/1/0675/5329/6700/files/camicia-misto-cotone-clergy-nero-manica-lunga-ecclesiashop-3_bb34d4b3-4723-426f-86bf-63c7d0003d3e.jpg?v=1764036117',
    'https://cdn.shopify.com/s/files/1/0675/5329/6700/files/camicia-misto-cotone-clergy-nero-manica-lunga-ecclesiashop-2_f151d8de-8118-4562-a4fe-968331f179b9.jpg?v=1790955812',
    'https://cdn.shopify.com/s/files/1/0675/5329/6700/files/camicia-misto-cotone-clergy-nero-manica-lunga-ecclesiashop-4_a33f9433-f5f2-4f3f-9f9d-44395c70dfc3.jpg?v=1764036117',
    'https://cdn.shopify.com/s/files/1/0675/5329/6700/files/camicia-misto-cotone-clergy-nero-manica-lunga-ecclesiashop-5_47eaf8c7-bfbb-4cbc-897b-5773250932cd.jpg?v=1764036117'
  ],
  Blu:[
    'https://cdn.shopify.com/s/files/1/0675/5329/6700/files/camicia-misto-cotone-clergy-blu-manica-lunga-ecclesiashop_8558e6b0-be2a-4d43-941c-52edcc473525.jpg?v=1790955854',
    'https://cdn.shopify.com/s/files/1/0675/5329/6700/files/camicia-misto-cotone-clergy-blu-manica-lunga-ecclesiashop-3.jpg?v=1764038577',
    'https://cdn.shopify.com/s/files/1/0675/5329/6700/files/camicia-misto-cotone-clergy-blu-manica-lunga-ecclesiashop-2_a68bdd2b-fc9b-4f8f-8a32-bafc52bf5cef.jpg?v=1790955854',
    'https://cdn.shopify.com/s/files/1/0675/5329/6700/files/camicia-misto-cotone-clergy-blu-manica-lunga-ecclesiashop-4.jpg?v=1764038577',
    'https://cdn.shopify.com/s/files/1/0675/5329/6700/files/camicia-misto-cotone-clergy-blu-manica-lunga-ecclesiashop-5.jpg?v=1764038577'
  ],
  Antracite:[
    'https://cdn.shopify.com/s/files/1/0675/5329/6700/files/camicia-misto-cotone-clergy-grigio-antracite-manica-lunga-ecclesiashop_0c599a04-f1da-4c5a-b493-554ab9bbd378.jpg?v=1790958714',
    'https://cdn.shopify.com/s/files/1/0675/5329/6700/files/camicia-misto-cotone-clergy-grigio-antracite-manica-lunga-ecclesiashop-3.jpg?v=1764037631',
    'https://cdn.shopify.com/s/files/1/0675/5329/6700/files/camicia-misto-cotone-clergy-grigio-antracite-manica-lunga-ecclesiashop-2_00625f9b-cb1f-4f11-ae92-2c19b4408b1b.jpg?v=1790958714',
    'https://cdn.shopify.com/s/files/1/0675/5329/6700/files/camicia-misto-cotone-clergy-grigio-antracite-manica-lunga-ecclesiashop-4.jpg?v=1764037631',
    'https://cdn.shopify.com/s/files/1/0675/5329/6700/files/camicia-misto-cotone-clergy-grigio-antracite-manica-lunga-ecclesiashop-5.jpg?v=1764037631'
  ],
  Grigio:[
    'https://cdn.shopify.com/s/files/1/0675/5329/6700/files/camicia-misto-cotone-clergy-grigio-manica-lunga-ecclesiashop_d391d360-882f-4221-8153-e7c1de3b61c7.jpg?v=1790958959',
    'https://cdn.shopify.com/s/files/1/0675/5329/6700/files/camicia-misto-cotone-clergy-grigio-manica-lunga-ecclesiashop-3_9c595467-23cd-4aeb-9982-e7c4d9b4f3ce.jpg?v=1768312299',
    'https://cdn.shopify.com/s/files/1/0675/5329/6700/files/camicia-misto-cotone-clergy-grigio-manica-lunga-ecclesiashop-2_feb66633-2a1f-43c6-a863-001f3cf9d8eb.jpg?v=1790958959',
    'https://cdn.shopify.com/s/files/1/0675/5329/6700/files/camicia-misto-cotone-clergy-grigio-manica-lunga-ecclesiashop-4_1b04f730-54f3-4061-b82d-d5e84b3bc681.jpg?v=1768312299',
    'https://cdn.shopify.com/s/files/1/0675/5329/6700/files/camicia-misto-cotone-clergy-grigio-manica-lunga-ecclesiashop-5_c23a128c-4e49-4538-afbf-fab193ccb40f.jpg?v=1768312299'
  ],
  Bianco:[
    'https://cdn.shopify.com/s/files/1/0675/5329/6700/files/camicia-misto-cotone-clergy-bianco-manica-lunga-ecclesiashop_db00fc52-bc5c-4986-b245-31571e0009d4.jpg?v=1790955933',
    'https://cdn.shopify.com/s/files/1/0675/5329/6700/files/camicia-misto-cotone-clergy-bianco-manica-lunga-ecclesiashop-3_b151a1b9-2b52-473b-b54f-b34d3efca61f.jpg?v=1764038517',
    'https://cdn.shopify.com/s/files/1/0675/5329/6700/files/camicia-misto-cotone-clergy-bianco-manica-lunga-ecclesiashop-2_329c7b8d-b133-4ee0-aa0b-b456ae2b4a01.jpg?v=1790955933',
    'https://cdn.shopify.com/s/files/1/0675/5329/6700/files/camicia-misto-cotone-clergy-bianco-manica-lunga-ecclesiashop-4_6d84ad1b-29e0-4e0a-b9f1-b847c6463a9f.jpg?v=1764038517',
    'https://cdn.shopify.com/s/files/1/0675/5329/6700/files/camicia-misto-cotone-clergy-bianco-manica-lunga-ecclesiashop-5_15490ecf-51e8-413c-8daa-76b740a01e4e.jpg?v=1764038517'
  ],
  Celeste:[
    'https://cdn.shopify.com/s/files/1/0675/5329/6700/files/camicia-misto-cotone-clergy-celeste-manica-lunga-ecclesiashop_209eef33-9451-442a-8c8f-2976f050c28a.jpg?v=1790956218',
    'https://cdn.shopify.com/s/files/1/0675/5329/6700/files/camicia-misto-cotone-clergy-celeste-manica-lunga-ecclesiashop-3.jpg?v=1764038311',
    'https://cdn.shopify.com/s/files/1/0675/5329/6700/files/camicia-misto-cotone-clergy-celeste-manica-lunga-ecclesiashop-2_5e01b070-0ddc-43d8-aed4-3495eb9c086b.jpg?v=1790956218',
    'https://cdn.shopify.com/s/files/1/0675/5329/6700/files/camicia-misto-cotone-clergy-celeste-manica-lunga-ecclesiashop-4.jpg?v=1764038311',
    'https://cdn.shopify.com/s/files/1/0675/5329/6700/files/camicia-misto-cotone-clergy-celeste-manica-lunga-ecclesiashop-5.jpg?v=1764038311'
  ]
};
let currentGalleryColor='';
function sizedImageUrl(url,width){
  const absolute=url.startsWith('//')?'https:'+url:url;
  if(/([?&])width=\d+/.test(absolute))return absolute.replace(/([?&])width=\d+/,'$1width='+width);
  return absolute+(absolute.includes('?')?'&':'?')+'width='+width;
}
function updateGalleryCounter(index,total){
  if(count)count.textContent=(index+1)+' / '+total;
}
function activateThumb(thumb,index){
  const thumbs=document.querySelectorAll('.thumb');
  thumbs.forEach(x=>x.classList.remove('active'));
  thumb.classList.add('active');
  if(hero){
    hero.src=thumb.dataset.src;
    hero.alt=thumb.dataset.alt||hero.alt;
  }
  updateGalleryCounter(index,thumbs.length);
}
function bindThumbs(){
  document.querySelectorAll('.thumb').forEach((thumb,index)=>thumb.addEventListener('click',()=>activateThumb(thumb,index)));
}
let touchStartX=0;
if(hero){
  hero.addEventListener('touchstart',event=>{touchStartX=event.changedTouches[0].clientX;},{passive:true});
  hero.addEventListener('touchend',event=>{
    const delta=event.changedTouches[0].clientX-touchStartX;
    if(Math.abs(delta)<42)return;
    const thumbs=Array.from(document.querySelectorAll('.thumb'));
    const activeIndex=Math.max(0,thumbs.findIndex(thumb=>thumb.classList.contains('active')));
    const nextIndex=delta<0?Math.min(activeIndex+1,thumbs.length-1):Math.max(activeIndex-1,0);
    if(thumbs[nextIndex]&&nextIndex!==activeIndex)activateThumb(thumbs[nextIndex],nextIndex);
  },{passive:true});
}
function updateGalleryForColor(color){
  const images=colorGalleries[color];
  if(!images||!thumbsWrap||!hero||currentGalleryColor===color)return;
  currentGalleryColor=color;
  thumbsWrap.textContent='';
  images.forEach((src,index)=>{
    const thumb=document.createElement('button');
    const alt='Camicia Polycotton '+color+' Clergy - immagine '+(index+1);
    thumb.className='thumb'+(index===0?' active':'');
    thumb.type='button';
    thumb.dataset.src=sizedImageUrl(src,1600);
    thumb.dataset.alt=alt;
    const img=document.createElement('img');
    img.width=1200;
    img.height=1500;
    img.src=sizedImageUrl(src,360);
    img.alt=alt;
    thumb.appendChild(img);
    thumbsWrap.appendChild(thumb);
  });
  hero.src=sizedImageUrl(images[0],1600);
  hero.alt='Camicia Polycotton '+color+' Clergy Manica Lunga';
  updateGalleryCounter(0,images.length);
  bindThumbs();
}
bindThumbs();

document.querySelectorAll('.swatch').forEach(s=>s.addEventListener('click',()=>{document.querySelectorAll('.swatch').forEach(x=>{x.classList.remove('active');x.setAttribute('aria-pressed','false');});s.classList.add('active');s.setAttribute('aria-pressed','true');document.getElementById('color1').value=s.dataset.color;syncBundleVariant();}));
document.querySelectorAll('.size-btn').forEach(b=>b.addEventListener('click',()=>{document.querySelectorAll('.size-btn').forEach(x=>x.classList.remove('active'));b.classList.add('active');document.getElementById('size1').value=b.textContent.trim();syncBundleVariant();}));

let offer='bundle';
let marketIsUS=false;
const builder=document.getElementById('builder'),freeItem=document.getElementById('freeItem'),discount=document.getElementById('discountLine');
document.querySelectorAll('.offer-option').forEach(o=>o.addEventListener('click',()=>{document.querySelectorAll('.offer-option').forEach(x=>x.classList.remove('active'));o.classList.add('active');offer=o.dataset.offer;
 if(offer==='single'){
   freeItem.style.display='none';discount.style.display='none';document.getElementById('qtyLabel').textContent='1 × Camicia Polycotton';document.querySelector('.bundle-head strong').textContent='Configura il capo';document.querySelector('.bundle-head span').textContent='ACQUISTO SINGOLO';
 }else{
   freeItem.style.display='block';discount.style.display='flex';document.getElementById('qtyLabel').textContent='2 × Camicia Polycotton · varianti identiche';document.querySelector('.bundle-head strong').textContent='Configura la variante';document.querySelector('.bundle-head span').textContent='2 CAMICIE IDENTICHE · 1 GRATIS';
 }
 updatePricing();
}));


// L'offerta prevede sempre due camicie completamente identiche.
const size1=document.getElementById('size1'), size2=document.getElementById('size2');
const color1=document.getElementById('color1'), color2=document.getElementById('color2');
const collar1=document.getElementById('collar1'), collar2=document.getElementById('collar2');
const sleeve1=document.getElementById('sleeve1'), sleeve2=document.getElementById('sleeve2');
function formatEuro(value){return '€'+Number(value).toFixed(2).replace('.',',');}
function updatePricing(){
  const unitPrice=collar1.value==='Romano'?55:45;
  const grossPrice=unitPrice*2;
  const unitLabel=formatEuro(unitPrice);
  const grossLabel=formatEuro(grossPrice);
  const perUnitLabel=formatEuro(unitPrice/2);
  document.getElementById('mainPrice').textContent=unitLabel;
  document.getElementById('mainCompare').textContent=offer==='bundle'?grossLabel:'';
  document.getElementById('savePill').textContent=offer==='bundle'?'Risparmi 50%':'Prezzo regolare';
  document.getElementById('perUnit').innerHTML=offer==='bundle'?'<strong>'+perUnitLabel+' per capo</strong> con l\'offerta 2×1':'<strong>'+unitLabel+'</strong> per una Camicia Polycotton';
  document.querySelector('[data-offer="single"] .offer-money strong').textContent=unitLabel;
  document.querySelector('[data-offer="bundle"] .offer-money strong').textContent=unitLabel;
  document.querySelector('[data-offer="bundle"] .offer-money s').textContent=grossLabel;
  document.querySelector('.bundle-item:not(.free) .bundle-label > span:last-child').textContent=unitLabel;
  document.querySelector('.bundle-item:not(.free) .bundle-price strong').textContent=unitLabel;
  document.querySelector('.bundle-item.free .bundle-price s').textContent=unitLabel;
  document.getElementById('subTotal').textContent=offer==='bundle'?grossLabel:unitLabel;
  document.querySelector('#discountLine span:last-child').textContent='− '+unitLabel;
  document.querySelector('.sum.total span:last-child').textContent=unitLabel;
  document.getElementById('addButton').textContent=offer==='bundle'?'AGGIUNGI 2 AL CARRELLO · '+unitLabel:'AGGIUNGI AL CARRELLO · '+unitLabel;
  document.getElementById('mobileOfferButton').textContent=marketIsUS?(offer==='bundle'?'BOGO · 2 SHIRTS · ':'1 SHIRT · ')+(unitLabel):(offer==='bundle'?'2 CAMICIE · ':'1 CAMICIA · ')+unitLabel;
  document.querySelector('#toast em').textContent='Risparmio visualizzato: '+unitLabel;
}
function syncBundleVariant(){
  size2.value=size1.value;
  color2.value=color1.value;
  collar2.value=collar1.value;
  sleeve2.value=sleeve1.value;
  document.getElementById('colorName').textContent=color1.value;
  document.getElementById('collarName').textContent=collar1.value==='Romano'?'Romano +10€':collar1.value;
  document.getElementById('sleeveName').textContent=sleeve1.value;
  const baseTitle=productRoot.dataset.productBase||'Camicia Polycotton';document.getElementById('productTitle').textContent=baseTitle+' — '+color1.value+' — '+collar1.value+' — Manica '+sleeve1.value;
  document.querySelectorAll('.swatch').forEach(x=>{const isActive=x.dataset.color===color1.value;x.classList.toggle('active',isActive);x.setAttribute('aria-pressed',isActive?'true':'false');});
  document.querySelectorAll('.size-btn').forEach(x=>x.classList.toggle('active',x.textContent.trim()===size1.value));
  document.querySelectorAll('[data-collar]').forEach(x=>x.classList.toggle('active',x.dataset.collar===collar1.value));
  document.querySelectorAll('[data-sleeve]').forEach(x=>x.classList.toggle('active',x.dataset.sleeve===sleeve1.value));
  updateGalleryForColor(color1.value);
  updatePricing();
}
document.querySelectorAll('[data-collar]').forEach(btn=>btn.addEventListener('click',()=>{collar1.value=btn.dataset.collar;syncBundleVariant();}));
document.querySelectorAll('[data-sleeve]').forEach(btn=>btn.addEventListener('click',()=>{sleeve1.value=btn.dataset.sleeve;syncBundleVariant();if(document.getElementById('sizeModal').classList.contains('open'))updateSizeGuideSleeve();}));
size1.addEventListener('change',syncBundleVariant);
color1.addEventListener('change',syncBundleVariant);
collar1.addEventListener('change',syncBundleVariant);
sleeve1.addEventListener('change',()=>{syncBundleVariant();if(document.getElementById('sizeModal').classList.contains('open'))updateSizeGuideSleeve();});
syncBundleVariant();

// Il termine americano viene mostrato esclusivamente nel mercato US.
const params=new URLSearchParams(window.location.search);
const path=window.location.pathname.toLowerCase();
const shopifyCountry=(window.Shopify&&window.Shopify.country)||'';
const isUS=shopifyCountry==='US'||params.get('country')==='US'||/(?:^|\/)(?:en|it|fr|es|de|pl|pt)-us(?:\/|$)/.test(path);
if(isUS){
  document.getElementById('marketOfferTag').textContent='BOGO';
  document.getElementById('marketOfferRibbon').textContent='2 IDENTICAL POLYCOTTON SHIRTS · SAME COLOR, SIZE, COLLAR & SLEEVE · SECOND SHIRT FREE';
  document.getElementById('bundleOfferName').textContent='BOGO · Buy 2, Pay 1';
  const faqOfferLabel=document.getElementById('faqOfferLabel');if(faqOfferLabel)faqOfferLabel.textContent='BOGO · Frequently asked questions';
  const faqHow=document.getElementById('faqHow');if(faqHow)faqHow.firstChild.nodeValue='How does BOGO work?';
  marketIsUS=true;
}
updatePricing();

document.querySelectorAll('.faq-btn').forEach(btn=>btn.addEventListener('click',()=>{const row=btn.parentElement;row.classList.toggle('open');btn.querySelector('i').textContent=row.classList.contains('open')?'−':'+';}));

const modal=document.getElementById('sizeModal');
const sizeGuideImageUrl=productRoot.dataset.sizeGuideImage;
if(modal&&sizeGuideImageUrl&&!modal.querySelector('.size-guide-image')){
  const imageWrap=document.createElement('figure');
  imageWrap.className='size-guide-image';
  imageWrap.setAttribute('aria-label','Schema guida taglie camicia');
  imageWrap.innerHTML='<img src="'+sizeGuideImageUrl+'" width="900" height="900" loading="lazy" decoding="async" alt="Schema guida taglie della camicia">';
  modal.querySelector('.modal-card').insertBefore(imageWrap,modal.querySelector('.size-guide-meta'));
}
let sizeUnit='cm';
const sizeGuideMeta=document.querySelector('.size-guide-meta');
if(sizeGuideMeta&&!sizeGuideMeta.querySelector('.size-unit-toggle')){
  sizeGuideMeta.insertAdjacentHTML('beforeend','<div class="size-unit-toggle" role="group" aria-label="Unità di misura"><button type="button" class="active" data-size-unit="cm" aria-pressed="true">CM</button><button type="button" data-size-unit="in" aria-pressed="false">IN</button></div>');
}
const sizeUnitToggle=document.querySelector('.size-unit-toggle');
function formatMeasurement(value,unit){
  const numeric=Number(String(value).replace(',','.'));
  if(unit==='in')return (numeric/2.54).toFixed(1).replace('.',',')+' in';
  return (Number.isInteger(numeric)?String(numeric):numeric.toFixed(1).replace('.',','))+' cm';
}
function updateSizeGuideUnit(unit){
  sizeUnit=unit;
  document.querySelectorAll('.size-table tbody td:not(:first-child)').forEach(cell=>{
    let cmValue=cell.dataset.cm;
    if(cell.classList.contains('sleeve-measure'))cmValue=cell.dataset.activeCm||cell.dataset.long;
    if(!cmValue)cmValue=cell.textContent.replace(/\s*(?:cm|in)$/,'').trim().replace(',','.');
    if(!cell.classList.contains('sleeve-measure'))cell.dataset.cm=cmValue;
    cell.textContent=formatMeasurement(cmValue,unit);
  });
  const unitLabel=sizeGuideMeta?.querySelector('strong');
  if(unitLabel)unitLabel.textContent='Misure ufficiali Polycotton · '+unit.toUpperCase();
  sizeUnitToggle?.querySelectorAll('[data-size-unit]').forEach(button=>{
    const isActive=button.dataset.sizeUnit===unit;
    button.classList.toggle('active',isActive);
    button.setAttribute('aria-pressed',isActive?'true':'false');
  });
}
sizeUnitToggle?.addEventListener('click',event=>{
  const button=event.target.closest('[data-size-unit]');
  if(button)updateSizeGuideUnit(button.dataset.sizeUnit);
});
function updateSizeGuideSleeve(){
  const isShort=sleeve1.value==='Corta';
  document.getElementById('sizeGuideSleeveLabel').textContent='Tabella aggiornata per: Manica '+sleeve1.value;
  document.querySelectorAll('.sleeve-measure').forEach(cell=>{
    cell.dataset.activeCm=isShort?cell.dataset.short:cell.dataset.long;
    cell.textContent=formatMeasurement(cell.dataset.activeCm,sizeUnit);
  });
}
function openSizeGuide(e){
  if(e)e.preventDefault();
  updateSizeGuideSleeve();
  modal.classList.add('open');
  modal.setAttribute('aria-hidden','false');
  document.body.style.overflow='hidden';
  document.getElementById('closeModal').focus();
}
function closeSizeGuide(){
  modal.classList.remove('open');
  modal.setAttribute('aria-hidden','true');
  document.body.style.overflow='';
}
document.getElementById('sizeGuide').addEventListener('click',openSizeGuide);
document.querySelectorAll('.size-guide-trigger').forEach(link=>link.addEventListener('click',openSizeGuide));
document.getElementById('closeModal').addEventListener('click',closeSizeGuide);
modal.addEventListener('click',e=>{if(e.target===modal)closeSizeGuide();});
document.addEventListener('keydown',e=>{if(e.key==='Escape'&&modal.classList.contains('open'))closeSizeGuide();});

document.getElementById('addButton').addEventListener('click',()=>{const one=[color1.value,size1.value,collar1.value,'Manica '+sleeve1.value].join(' · ');const two=[color2.value,size2.value,collar2.value,'Manica '+sleeve2.value].join(' · ');document.getElementById('toastCopy').textContent=offer==='bundle'?('1) '+one+'  ·  2) '+two):one;const toast=document.getElementById('toast');toast.querySelector('strong').textContent=offer==='bundle'?'Offerta 2×1 configurata':'Articolo configurato';toast.querySelector('em').style.display=offer==='bundle'?'inline':'none';toast.classList.add('show');setTimeout(()=>toast.classList.remove('show'),4000)});
});
